import { Component, OnChanges, ChangeDetectionStrategy, Input, Output, EventEmitter, SimpleChanges } from '@angular/core'
import { FormControl, UntypedFormGroup } from '@angular/forms'
import { Property } from '@app/shared/models/common-models'
import { PropertyChangeArgs } from '@app/shared/models/entity-update.model'
import { EntityService } from '@app/shared/services/entity.service'

@Component({
  selector: 'app-entity-boolean-property',
  templateUrl: './boolean-property.component.html',
  styleUrls: ['./boolean-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BooleanPropertyComponent implements OnChanges {
  @Input() property: Property

  @Input() formGroup: UntypedFormGroup

  @Output() propertyChange = new EventEmitter<PropertyChangeArgs>()

  propertyForm: FormControl<boolean>

  toolTipTextId: string

  constructor(private entityService: EntityService) {
    this.propertyForm = new FormControl<boolean>(null, { updateOn: 'change' })
    this.propertyForm.valueChanges.subscribe(value => {
      const event: PropertyChangeArgs = {
        Key: this.property.Key,
        Value: value,
        MeasurementUnitKey: this.property.MeasurementUnit,
      }
      this.propertyChange.emit(event)
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.property &&
      changes.formGroup &&
      changes.formGroup.currentValue &&
      changes.formGroup.previousValue !== changes.formGroup.currentValue
    ) {
      changes.formGroup.currentValue.setControl(this.property.Key, this.propertyForm, { emitEvent: false })
    }
    if (changes.property && this.property) {
      this.updatePropertyForm()
    }
  }

  updatePropertyForm() {
    if (this.propertyForm.pristine || this.propertyForm.valid) {
      this.propertyForm.setValue(this.property.Value === true || this.property.Value === 'true', { emitEvent: false })
      this.propertyForm.markAsPristine()
    }
    if (this.property.IsEnabled) {
      this.propertyForm.enable({ emitEvent: false })
    } else {
      this.propertyForm.disable({ emitEvent: false })
    }

    this.propertyForm.updateValueAndValidity({ emitEvent: false })

    this.toolTipTextId = this.entityService.getMetadataValue(this.property, 'TooltipTextId')
  }

  isActionButton = (property: Property): boolean => {
    return this.entityService.getMetadata(property, 'UIType')?.Value === 'ActionButton'
  }
}
